/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const PowerDriverSeat = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 24 26" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M22.57 19.59a2.46 2.46 0 0 0-2.35-.7c-2.4.25-7.86 1.39-10.81 2v-.08c2-4.47-1.52-9.72-3.23-12.24a13.18 13.18 0 0 1-.76-1.18C4.86 6.17 4.23 5.3 3.21 5.12h-.44c.14-.38.26-.65.38-.65.35 0 .51-.1.64-.59S2.55 1.12 2.55 1.12A2 2 0 0 0 .1.8c-.3.38 1.83 6.79 1.83 6.79L4.78 20a2.05 2.05 0 0 0-.21 1.57l1.23 3.81a.43.43 0 0 0 .41.3h15a.43.43 0 0 0 .41-.3l.86-2.57v-.07c.25-.53.86-2.16.09-3.15zM18 1.5A5.5 5.5 0 1 0 23.5 7 5.51 5.51 0 0 0 18 1.5zm0 1a4.49 4.49 0 0 1 4.45 4h-2.52a2 2 0 0 0-3.86 0h-2.52a4.49 4.49 0 0 1 4.45-4zm-4.45 5h2.52a2 2 0 0 0 1.43 1.43v2.52a4.47 4.47 0 0 1-3.95-3.95zm4.95 3.95V8.93a2 2 0 0 0 1.43-1.43h2.52a4.47 4.47 0 0 1-3.95 3.95z" /></g>
      </g>
    </svg>
  </span>
);

PowerDriverSeat.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

PowerDriverSeat.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default PowerDriverSeat;
